import React, {Component} from 'react'
import {connect} from 'react-redux';
import {setDateDisp, setFetchState, setServiceState} from "../../../actions";
import Swal from 'sweetalert2'
import {months_es, months_en} from '../../../constants/trips'
import './../../CalendarLeft/RouteName/style.css'
import {url_server} from "../../../constants/server";
import {translateLang} from "../../../constants/traductions";

class MonthYear extends Component {

  listarMeses(lang) {

    if (lang === 'en') {
      let d = new Date();
      let mes_actual = d.getMonth();

      for (let m=0; m < mes_actual; m++) {
        delete months_en[m];
      }

      return months_en;
    }
    else {
      let d = new Date();
      let mes_actual = d.getMonth();

      for (let m=0; m < mes_actual; m++) {
        delete months_es[m];
      }

      return months_es;
    }

  }

  changeMY = async (mes) => {

    await Swal.fire({
      title: translateLang('select_month', this.props.store.language),
      input: 'select',
      // inputOptions: months,
      inputOptions: this.listarMeses(this.props.store.language),
      inputValue: mes,
      showCancelButton: true,
      cancelButtonText: translateLang('cancel', this.props.store.language),
      inputValidator: async (value) => {

        // marcar estado de fetching en true
        this.props.setFetchState({
          fetchingState: true
        });

        // fetch
        const newDisp = await this.getDataFromServer(value);

        // marcar estado de fetching en false
        this.props.setFetchState({
          fetchingState: false
        });

        if (newDisp) {
          // set new mes AND dataDisp in store
          this.props.setDateDisp({
            mes: parseInt(value),
            dataDisp: newDisp
          });
        }

        else {
          this.props.setServiceState('inactive');
        }

      }
    });

  };

  async getDataFromServer(mes) {

    let data;

    try {
      const res = await fetch(`${url_server}/boleto/disponibilidad`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          "idRuta": this.props.store.idRuta,
          "mes": parseInt(mes) + 1, // el mes es del 1 al 12 en el server
          "anio": this.props.store.anio
        })
      });

      data = await res.json();

      return data;

    } catch (e) {
      console.error(e)
    }

  }

  render() {

    // let month = this.getMonth(this.props.store.mes);
    let anio = this.props.store.anio;

    return (
      <div>
        <h2 className="rt-name" onClick={() => this.changeMY(this.props.store.mes)}>
          <strong>{ translateLang('mes_'+(this.props.store.mes + 1), this.props.store.language) }</strong> {anio}
        </h2>
      </div>
    );
  }

}

const mapStateToProps = store => ({
  store
});
const mapDispatchToProps = dispatch => ({
  setDateDisp: value => dispatch(setDateDisp(value)),
  setFetchState: value => dispatch(setFetchState(value)),
  setServiceState: value => dispatch(setServiceState(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(MonthYear);
